<template>
  <div class="analysis-page" :class="{ 'menu-open': menuOpen }">
    <LoadingIndicator v-if="busy" />
    <AnalysisNavigation :current="$route.path" />
    <div class="main">
      <AnalysisHeader
        v-if="!noHeader"
        :pageName="pageName"
        :title="title"
        :select="select"
        :button="button"
        :disabled="disabled"
        :menuButton="!$route.path.includes('dashboard')"
      >
        <slot name="action" />
      </AnalysisHeader>
      <slot />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AnalysisHeader from '@/components/molecules/AnalysisHeader'
import AnalysisNavigation from '@/components/molecules/AnalysisNavigation'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'

/**
 * 分析画面のテンプレート
 */
export default {
  name: 'AnalysisPage',
  components: {
    AnalysisHeader,
    AnalysisNavigation,
    LoadingIndicator,
  },
  props: {
    /** ページの名前 */
    pageName: { type: String, default: '' },
    /** ページタイトル */
    title: { type: String, default: '' },
    /** データが存在する最初の日時 */
    select: { type: Number, default: null },
    /** ダウンロードボタンの表示制御 */
    button: { type: Boolean, default: true },
    /** ダウンロードボタンの活性制御 */
    disabled: { type: Boolean },
    busy: { type: Boolean, default: false },
    noHeader: { type: Boolean, default: false },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      menuOpen: state => state.analysis.menuOpen,
    }),
  },
  methods: {},
}
</script>

<style lang="postcss" scoped>
.analysis-page {
  background: var(--very-light-gray-4);
  display: flex;
  flex: 1;
  min-height: 100%;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative;
  transition: all 0.3s;

  .analysis-menu {
    left: -184px;
    position: absolute;
    transition: all 0.3s;
  }

  &.menu-open {
    padding-left: 184px;
    .analysis-menu {
      left: 0;
    }
  }
}

.main {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.responsive {
  .analysis-page {
    padding-left: 0;

    .analysis-menu {
      display: none;
    }
  }
}
</style>
